import script from "./tableauPotentielNourricierParCategorie.vue?vue&type=script&setup=true&lang=js"
export * from "./tableauPotentielNourricierParCategorie.vue?vue&type=script&setup=true&lang=js"

import "./tableauPotentielNourricierParCategorie.vue?vue&type=style&index=0&id=4a9b2105&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a9b2105"]])

export default __exports__